import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-document_fill",
  "use": "icon-document_fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-document_fill\"><path d=\"M768 960H256c-70.692 0-128-57.308-128-128V192c0-70.692 57.308-128 128-128h415.725c8.303-0.079 16.629 3.036 22.964 9.371L886.597 265.28c6.273 6.273 9.398 14.499 9.383 22.721h0.02v544C896 902.692 838.692 960 768 960zM320 768h384c17.673 0 32-14.327 32-32s-14.327-32-32-32H320c-17.673 0-32 14.327-32 32s14.327 32 32 32z m-32-224c0 17.673 14.327 32 32 32h384c17.673 0 32-14.327 32-32s-14.327-32-32-32H320c-17.673 0-32 14.327-32 32z m512-256H672V160c0-17.673-14.327-32-32-32s-32 14.327-32 32v160c0 17.673 14.327 32 32 32h160c17.673 0 32-14.327 32-32 0-17.673-14.327-32-32-32z\" p-id=\"26803\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/document_fill.svg
// module id = QrkA
// module chunks = 12